//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    forkliftTruckRequests: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    getIndicatorStyle: function () {
      const top = 3 * (this.forkliftTruckRequests.length - 1)
      return `top:${top}px;`
    },
    getIconStyle: function (request, index) {
      let style = `color:${this.getColor(request)}; `
      let top = -4 * index
      let right = -4 * index
      if (request._blank) {
        top--
        right--
      }
      const zIndex = 100 - index
      style += `top:${top}px; right:${right}px; z-index:${zIndex};`
      return style
    },
    getColor: function (request) {
      if (request._blank) {
        return 'white'
      } else if (request.assignmentType === 'current') {
        return request.bpState.color
      } else {
        return 'grey'
      }
    },
    getTooltip: function () {
      const assignedRequests = this.forkliftTruckRequests.filter(r => r.assignmentType === 'current')
      const text = `Автовышки: ${this.forkliftTruckRequests.length}` + (assignedRequests.length ? ` (назначено: ${assignedRequests.length})` : '')
      return text
    }
  }
}

